import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import ActionButton from '../../../../webcommon/common/actionbutton/ActionButton';
import TextInput from '../../../../webcommon/common/formcomponents/textinput/TextInput';
import { noop } from 'lodash';
import defaultStyles from './SaveAs.module.scss';
import LoadingText from '../loadingtext/LoadingText';

const SaveAs = (props) => {
    const { setSaveTemplateName, saveAsTemplate } = props;
    const setTemplateName = useCallback((e) => {
        setSaveTemplateName(e.target.value);
    }, [setSaveTemplateName]);

    const formSubmitMemoized = useCallback((e) => {
        saveAsTemplate();
        e.preventDefault();
    }, [saveAsTemplate]);

    return (
        <div className={ props.styles.saveAsWrapper }>
            <div className={ props.styles.saveAsHeader }>
                Save As
            </div>
            <form onSubmit={ formSubmitMemoized }>
                <div className={ props.styles.searchBox }>
                    <TextInput
                        value={ props.templateSaveName }
                        onChange={ setTemplateName }
                        placeholder="Template Name"
                    />
                </div>
                <div className={ props.styles.saveButton }>
                    <ActionButton
                        accent
                        onClick={ props.saveAsTemplate }
                    >
                        Save
                    </ActionButton>
                </div>
            </form>
            {props.templateSaved
                ? <div className={ props.styles.templateSaved }>Template Saved</div> : null}

            {!props.templateSaved && props.inProcessOfSaving
                ? <div className={ props.styles.templateSaved }> <LoadingText text="Loading" /></div> : null}
        </div>
    );
};

SaveAs.propTypes = {
    inProcessOfSaving: PropTypes.bool,
    saveAsTemplate: PropTypes.func,
    templateSaveName: PropTypes.string,
    setSaveTemplateName: PropTypes.func,
    styles: PropTypes.objectOf(PropTypes.string),
    templateSaved: PropTypes.bool
};

SaveAs.defaultProps = {
    saveAsTemplate: noop,
    inProcessOfSaving: false,
    templateSaveName: '',
    setSaveTemplateName: noop,
    styles: defaultStyles,
    templateSaved: false
};

export default SaveAs;
